export const Telegram = window.Telegram.WebApp;
